// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo-6ge8-qBb","logo_box":"logo_box-pJFJb_yu","breadcrumbs":"breadcrumbs-1nBD5-4_"};